import { FC } from 'react'
import styles from 'components/features/external/PublicDashboardModuleWrapper/PublicDashboardModuleWrapper.styl'
import cn from 'classnames'

type PublicDashboardModuleWrapperProps = {
  title?: string
  subtitle?: string
  noPadding?: boolean
}

export const PublicDashboardModuleWrapper: FC<PublicDashboardModuleWrapperProps> = (props) => {
  const { children, title, subtitle, noPadding } = props

  const className = cn(styles.publicDashboardModuleWrapper, {
    [styles.noPadding]: noPadding,
  })

  return (
    <div className={ className }>
      <div className={ styles.header }>
        { title && (
          <h2 className={ styles.title }>{ title }</h2>
        )}
        { subtitle && (
          <h3 className={ styles.subtitle }>{ subtitle }</h3>
        )}
      </div>
      <div className={ styles.content }>
        { children }
      </div>
    </div>
  )
}
